import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditService from "../../components/services/FormAddEditService";
import { useGetService } from "../../hooks/services/useGetService";
import LoadingPage from "../../components/global/LoadingPage";

const EditService = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, service } = useGetService(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/services");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditService
                isEdit={true}
                currentData={service}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditService;